import { z } from 'zod';
import { SchemaEmail } from '@axiom/types';

export const AdHocContactSchema = z.object({
  firstName: z.string().trim().min(1, {
    message: 'Required',
  }),
  lastName: z.string().trim().min(1, {
    message: 'Required',
  }),
  email: SchemaEmail,
});

export type AdHocContact = z.infer<typeof AdHocContactSchema>;

export const TalentInterviewConfirmModalSchema = z
  .object({
    contacts: z.array(z.string().uuid()),
    isZoomNotPreferred: z.boolean(),
    adHocContacts: z.array(AdHocContactSchema),
    errorSelectAtLeastOne: z.string().optional(),
    errorMissMatchEmailDomain: z.string().optional(),
    availabilityNote: z.string().optional(),
    rateConfirmed: z.boolean(),
    ALL_CONTACTS: z.string().optional(),
  })
  .refine(
    ({ contacts, adHocContacts }) => {
      // checking for no client selected or added
      const hasSelected: boolean = contacts.length > 0;
      const hasAdHoc: boolean = adHocContacts.length > 0;

      return hasSelected || hasAdHoc;
    },
    {
      message: 'At least one contact must be selected or added',
      path: ['errorSelectAtLeastOne'],
    }
  )
  .refine(
    ({ rateConfirmed }) => {
      return rateConfirmed;
    },
    {
      message: 'Required',
      path: ['rateConfirmed'],
    }
  );

export type TalentInterviewConfirmModalType = z.infer<
  typeof TalentInterviewConfirmModalSchema
>;
